import { c as _c } from "react/compiler-runtime";
import { GrowthBook } from '@growthbook/growthbook-react';
import { NextRouter } from 'next/router';
import { useEffect } from 'react';
function updateGrowthBookURL(gb: GrowthBook) {
  gb.setURL(window.location.href);
}
export function useInitGrowthBook(gb, router) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== gb || $[1] !== router.events) {
    t0 = () => {
      if (!gb) {
        return;
      }
      const gaUserId = document.cookie.match(/_ga=(.+?);/)?.[1].split(".").slice(-2).join(".");
      if (!gaUserId) {
        return;
      }
      gb.init({
        streaming: true
      });
      gb.setAttributes({
        id: gaUserId,
        viewportWidth: window.innerWidth
      });
      router.events.on("routeChangeComplete", () => updateGrowthBookURL(gb));
      return () => router.events.off("routeChangeComplete", () => updateGrowthBookURL(gb));
    };
    t1 = [gb, router.events];
    $[0] = gb;
    $[1] = router.events;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}